import { SkyBadge } from "@skypointcloud/skypoint-ui";

/**
 * A count after a toggle's label (owner feedback 2026-09-28: "Models 5" and "Passed 23" read as
 * bare digits glued to a word). The label stays the button's word; the count is a neutral pill,
 * muted when it is zero so the eye skips it. The space before the pill is real text, so the
 * button's accessible name reads "Passed 23", never "Passed23".
 *
 * Outlined, not tinted: the pressed toggle is the secondary button, whose fill is `bg-muted`, the
 * same fill as a tint/subtle badge, so a tinted pill vanished into the pressed button and read as
 * a bare digit again (review r1, B1). A border on a transparent fill reads on both.
 *
 * `SkyBadge` renders `role="status"`: the badge is keyed by its count, so a changed count mounts
 * a new badge rather than changing the text of a live one (as `TransformationStatusLine` does).
 * `data-muted` marks a zero count for tests; the pill's look is the library's.
 */
export function CountPill({ count, testId }: { count: number; testId: string }) {
  const zero = count === 0;
  return (
    <>
      {" "}
      <span
        className="inline-flex align-middle"
        data-testid={testId}
        data-muted={zero ? "true" : undefined}
      >
        <SkyBadge key={count} appearance={zero ? "ghost" : "outline"} color="subtle" size="medium">
          {count}
        </SkyBadge>
      </span>
    </>
  );
}
